import React from "react"
import { useTranslation } from "react-i18next"
import PageMeta from "./PageMeta"

const FrontPageMeta = ({ language }) => {
  const { t } = useTranslation("generic")

  return (
    <PageMeta
      language={language}
      title={t("##.Meta.Title")}
      description={t("##.Meta.Description")}
    />
  )
}

export default FrontPageMeta
